import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { File } from 'app/models/file'

@Component({
  selector: 'app-media-player',
  templateUrl: './media-player.component.html',
  styleUrls: ['./media-player.component.scss']
})
export class MediaPlayerComponent {
  @ViewChild('video') videoElement: ElementRef

  @Input() set file(file: File) {
    this.url = file.fileUrl
    this.isMp4Source = file.name.split('.').reverse()[0] !== 'webm'
    if (this.videoElement?.nativeElement) {
      this.videoElement.nativeElement.load()
    }
    this.detectorChanges.detectChanges()
  }
  protected url: string

  protected isMp4Source: boolean

  constructor(private detectorChanges: ChangeDetectorRef) {}
}
